import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper, withErrorBoundary } from 'ui';
import { CommunitySideCards } from '../community-side-cards';
import { CommunityJoinButtons } from './community-join-buttons';
import { Description } from './description';

export type P = {
  community: CommunityDetail;
};

const CommunityAbout = ({ community }: P) => (
  <ContentWrapper aside={<CommunitySideCards community={community} />}>
    <CommunityJoinButtons community={community} />
    <Description community={community} />
    {/* TODO: Will be used in Task #87927 for Community about invite */}
  </ContentWrapper>
);

export default withErrorBoundary(CommunityAbout);
